import { memo } from 'react';
import classNames from 'classnames/bind';

// components
import Breadcrumbs from '../../Breadcrumbs';
import NewTag from '../../Shared/NewTag';

// constants
import { SEO_INSIDER_TRANSACTIONS_BREADCRUMBS } from '../../../data/directory/constants';

import loadable from '../../../utils/loadable';

import withComponentName from '../../../decorators/withComponentName';
import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';

import Styles from './styles.module.scss';
import Tooltip from '../../Tooltip';

const InsiderTransactionsTable = loadable(() => import('../InsiderTransactionsTable'));

const cx = classNames.bind(Styles);

const contentStyle = {
  transform: 'translateX(calc(-50% + 8px)',
  left: 0,
  width: '300px',
  zIndex: 100001,
  bottom: '30px',
};

export const InsiderTransactionsPage = () => (
  <section className={cx('insider-transactions-page-wrapper')}>
    <div className={cx('insider-transactions-page')}>
      <Breadcrumbs className={cx('insider-transactions-page__breadcrumbs')} items={SEO_INSIDER_TRANSACTIONS_BREADCRUMBS} />
      <div className={cx('insider-transactions-page__header')}>
        <h1 className={cx('insider-transactions-page__title')}>Insider Transactions</h1>
        <Tooltip
          className={Styles.tooltip}
          contentStyle={contentStyle}
          dynamicPosition
        >
          Transaction data is extracted from filings by machine learning and may not reflect
          corporate actions like splits or actions that have occurred since
          the last relevant filing. Only reported data is available.
          Older last-filing dates may impact any aggregate data.
          Please verify accuracy and completion before making investment decisions.&nbsp;
          <a
            href="https://www.cityfalcon.ai/features/insider-transactions"
          >
            Learn more.
          </a>
        </Tooltip>
        <NewTag className={cx('tag')} />
      </div>
      <p className={cx('insider-transactions-page__description')}>
        Buys, sells, stock option exercises and other transactions from key people are&nbsp;
        sourced from SEC Form 4 and other top regulators and forms. The data is organised&nbsp;
        and structured to make due diligence easier for all market participants.
      </p>
      <InsiderTransactionsTable
        singlePage
        multipleCompanies
      />
    </div>
  </section>
);

export default memo(withMetatag(withComponentName(InsiderTransactionsPage), 'directory/insider-transactions'));
